import table from './pdf_structure_table_2025';
import tableSmall from './pdf_structure_table_small_2025';
import { toCurrency } from './helpers';

export default function month(data, number, variables) {
    //var num = new Intl.NumberFormat("ru-RU", {minimumFractionDigits: 2});
    var chooseTable = function (number) {
        if (number === 3) {
            return table(data, number, variables);
        } else {
			return tableSmall(data, number, variables);
        }
    };

    var toPay = function (number) {
        if (number === 3) {
            return data.bill.paySumm[0];
        } else {
            return data.bill.billPoint[number].duty[0];
        }
    };
 
    return {
        margin: [-23,0,0,0], /*отступы (-23 с левого края)*/ 
        table: {
            headerRows: 0,
            widths: [550], /*ширина таблицы*/
            body: [
                   [{text: variables.ufc.text, margin: [-2, -2, -5, -2], style: variables.ufc.style}],
                [
                    [
                        {
                            columns: [
                                
                                {
                                    width: 366,
                                    table: {
                                        headerRows: 0,
                                        body: [
                                          /*  [{text: variables.ufc.text, style: variables.ufc.style}],*/
                                            [
                                                {
                                                    table: {
                                                        body: [
                                                            [
                                                                {
                                                                    columns: [
                                                                        {
                                                                            width: 67,
                                                                            style: "underNotesSmall",
                                                                            text: 'наниматель'
                                                                        },
                                                                        {

                                                                            width: 134,
                                                                            style: "underNotesSmall",
                                                                            text: data.bill.person[0].fullname[0]
                                                                        },
                                                                        {
                                                                            width: 70,
                                                                            style: "underNotesSmall",
                                                                            text: "лицевой счет"
                                                                        },
                                                                        {
                                                                            width: 95,
                                                                            style: "underNotesSmall",
                                                                            text: data.bill.contractNumber[0]
                                                                        }
                                                                    ], margin: [0, -4, 0, 0]
                                                                }
                                                            ],
                                                            [
                                                                {
                                                                    columns: [
                                                                        {
                                                                            width: 67,
                                                                            style: "underNotesSmall",
                                                                            text: "адрес"
                                                                        },
                                                                        {
                                                                            width: 200,
                                                                            style: "underNotesSmall",
                                                                            text: data.bill.address[0]
                                                                        }
                                                                    ], margin: [0, -2, 0, 0]
                                                                }
                                                            ],
                                                            [
                                                                {
                                                                    columns: [
                                                                        {
                                                                            width: 45,
                                                                            style: "underNotesSmall",
                                                                            text: "Площадь:"
                                                                        },
                                                                        {
                                                                            width: 55,
                                                                            style: "underNotesSmall",
                                                                            text: toCurrency(data.bill.billPoint[0].area[0].value[0]) + " м2"
                                                                        },
                                                                        {
                                                                            width: 35,
                                                                            style: "underNotesSmall",
                                                                            text: "Тариф:"
                                                                        },
                                                                        {
                                                                            width: 55,
                                                                            style: "underNotesSmall",
                                                                            text: toCurrency(data.bill.billPoint[0].tariff[0].value[0]) + " руб."
                                                                        }
                                                                    ], margin: [0, -2, 0, 0]
                                                                }
                                                            ]
                                                        ]
                                                    },
                                                    layout: "noBorders"
                                                }
                                            ]
                                        ]
                                    },
                                    layout: {
                                        hLineWidth: function (i, node) {
                                            return (i === 0 || i === node.table.body.length) ? 0 : 0.5;
                                        },
                                        vLineWidth: function (i, node) {
                                            return (i === 0 || i === node.table.widths.length) ? 0 : 0.5;
                                        },
                                        hLineColor: function (i, node) {
                                            return (i === 0 || i === node.table.body.length) ? "black" : "black";
                                        },
                                        vLineColor: function (i, node) {
                                            return (i === 0 || i === node.table.widths.length) ? "black" : "black";
                                        }
                                    }
                                },
                                {
                                    table: {
                                        headerRows: 0,
                                        widths: [170], /*ширина таблицы в картинкой и уином*/ 
                                        body: [
                                                /*строка с штрих-кодом, если нет уин, то не отображаем код*/
                                            //[(data.bill.uin ? {image: data.bill.barCode, alignment: "center", width: 93, margin: [0, -20, 0, 0]/*style: "Image_kod_small"*/} : {text: " "})],
                                            [{text: " "}]
                                        ]
                                    },
                                    layout: "noBorders"
                                }
                            ]
                        },
                        {
                            columns: [
                                chooseTable(number),
                                {
                                    table: {
                                        headerRows: 0,
                                        widths: [150, 80],
                                        body: [
                                            [
                                                {text: `За ${data.bill.billPoint[number].charDate[0]}\nК оплате ` + toCurrency(toPay(number)) + " руб.", 
                                                margin: [5, 0, 0, 0], bold: true, fontSize: 10},
                                                (data.bill.uin ? {image: "data:image/jpeg;base64," + data.bill.billPoint[number].QRImage[0], 
                                                    alignment: "right", width: 85, height: 85, margin: [0, -36, 0, -8]} : {text: " "}),
                                            ],
                                            [
                                                {text: (data.bill.billPoint[number].uinm[0] ? "УИН: " + data.bill.billPoint[number].uinm[0] : " "), 
                                                    fontSize: 8, bold: true, alignment: "right", margin: [30, 2, 0, -1], colSpan: 2},
                                                {}
                                            ],
                                        ]
                                    },
                                    layout: "noBorders"
                                }
                            ]
                        }
                    ]
                ]
            ]
        }
    };
};



// WEBPACK FOOTER //
// ./src/pdf_structure_small_2025.js